import {pushToDataLayer} from './pushToDataLayer';

/**
 * Envoie l'événement de liste d'éléments vue pour la section émission recentes au dataLayer.
 *
 * @param {string} item_list_id - L'ID de la liste d'éléments.
 * @param {string} item_list_name - Le nom de la liste d'éléments.
 * @param {Array} items - Un tableau d'éléments d'émission.
 */
export const pushEmissionViewItemListToDataLayer = (item_list_id, item_list_name, items) => {
    try {
        if (!Array.isArray(items)) {
            console.warn('DataLayer Invalid items:', items);
            return;
        }

        const eventParams = {
            item_list_id,
            item_list_name,
            items: items.map((item, index) => {
                if (!item || !item.emissionId || !item.titre || !item.type || !item.emission || !item.emission.type || 
                    !item.emission.id || !item.emission.slug || !item.emission.nom) {
                    console.warn('Invalid item:', item);
                    return null;
                }
                return {
                    item_id: item.emissionId,
                    item_name: item.titre,
                    item_category: item.type,
                    index,
                    location_id: `${item.emission.type}/${item.emission.id}/${item.emission.slug}`,
                    variant: item.emission.nom,
                    item_list_id,
                    item_list_name
                };
            }).filter(Boolean), // Supprime tous les éléments nuls
        };

        pushToDataLayer('view_item_list', eventParams);
    } catch (error) {
        console.error('DataLayer Error in pushEmissionViewItemListToDataLayer:', error);
    }
};

/**
 * Envoie l'événement de sélection d'élément pour la section émission recentes au dataLayer.
 *
 * @param {string} item_list_id - L'ID de la liste d'éléments.
 * @param {string} item_list_name - Le nom de la liste d'éléments.
 * @param {Object} item - L'élément à sélectionner.
 */
export const pushEmissionSelectItemToDataLayer = (item_list_id, item_list_name, item) => {
    try {
        if (!item || !item.emissionId || !item.titre || !item.type || !item.emission || !item.emission.type || 
            !item.emission.id || !item.emission.slug || !item.emission.nom) {
            console.warn('DataLayer Invalid item:', item);
            return;
        }

        const eventParams = {
            item_list_id,
            item_list_name,
            items: [
                {
                    item_id: item.emissionId,
                    item_name: item.titre,
                    item_category: item.type,
                    index: 0,
                    location_id: `${item.emission.type}/${item.emission.id}/${item.emission.slug}`,
                    variant: item.emission.nom,
                    item_list_id,
                    item_list_name
                }
            ]
        };

        pushToDataLayer('select_item', eventParams);
    } catch (error) {
        console.error('DataLayer Error in pushEmissionSelectItemToDataLayer:', error);
    }
};

/**
 * Envoie l'événement de sélection d'élément pour le bouton explorer pour la section émission recentes au dataLayer.
 */
export const pushEmissionSelectItemExploreToDataLayer = () => {
    try {
        const item_list_id = 'accueil-emissions-recentes';
        const item_list_name = 'Accueil Emissions Recentes';

        const eventParams = {
            item_list_id,
            item_list_name,
            items: [
                {
                    item_id: 'explorer-emissions',
                    item_name: 'Explorer les émissions',
                    item_category: 'Button',
                    index: 0,
                    item_list_id,
                    item_list_name
                }
            ]
        };

        pushToDataLayer('select_item', eventParams);
    } catch (error) {
        console.error('DataLayer Error in pushEmissionSelectItemExploreToDataLayer:', error);
    }
};
